export default __webpack_public_path__ + "static/media/Group9222.1d1e6bc4.svg";